import classNames from "classnames";
import { useEffect, useState } from "react";

const Loading = ({
  text,
  size,
  classname,
  stepIntervalMs = 3200,
  progressDurationMs,
  progressKey,
}) => {
  const [count, setCount] = useState(0);
  const [progress, setProgress] = useState(0);

  const textKey = Array.isArray(text) ? text.join("\u0001") : "";

  useEffect(() => {
    setCount(0);
  }, [textKey, progressKey]);

  useEffect(() => {
    const n = textKey ? textKey.split("\u0001").length : 0;
    if (n < 2 || count + 1 >= n) return undefined;
    const id = setTimeout(() => {
      setCount((c) => c + 1);
    }, stepIntervalMs);
    return () => clearTimeout(id);
  }, [count, textKey, stepIntervalMs]);

  useEffect(() => {
    if (!progressDurationMs) return undefined;

    setProgress(0);
    const start = performance.now();
    let rafId;

    const tick = (now) => {
      const elapsed = now - start;
      const pct = Math.min((elapsed / progressDurationMs) * 100, 100);
      setProgress(pct);
      if (pct < 100) {
        rafId = requestAnimationFrame(tick);
      }
    };

    rafId = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId);
  }, [progressDurationMs, progressKey]);

  return (
    <>
      <div className={classNames("loader", classname, `loader--${size}`)}></div>
      {progressDurationMs != null && (
        <div className="loader__progress">
          <div
            className="loader__progressBar"
            style={{ width: `${progress}%` }}
          />
        </div>
      )}
      {text && <div className="loader__text">{text[count]}</div>}
    </>
  );
};

export default Loading;
